import React, { createContext, useContext, useState } from "react";
import Toast from "../components/Toast/Toast"

export type ToastType = 'success' | 'error';

interface ToastContextType {
    showToast: (message: string, type?: ToastType) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within a ToastProvider");
    }
    return context;
};

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toastMessage, setToastMessage] = useState<string | null>(null);
    const [toastType, setToastType] = useState<ToastType>('error');

    const showToast = (message: string, type: ToastType = 'error') => {
        setToastMessage(message);
        setToastType(type);
    };

    const closeToast = () => {
        setToastMessage(null);
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            {toastMessage && <Toast message={toastMessage} type={toastType} onClose={closeToast} />}
        </ToastContext.Provider>
    );
};
